import {
    Form, FormButton, FormItem, FormSubmitHandler, TextInput,
} from "@sis/react-library"
import { ExampleDto } from "./FormSamplesSubmitButtonOnlyPage";

/////////////////////////////////////////////////////////////////////////////////////////////
// Interface for the form (see basic usage example for more information).
/////////////////////////////////////////////////////////////////////////////////////////////
// allow no members for shorter name to be more readable below
// eslint-disable-next-line
interface T extends ExampleDto { }

interface FormSamplesSubmitButtonOnlyFormProps {
    onSubmit: FormSubmitHandler<ExampleDto>;
    submitting: boolean;
}

export const FormSamplesSubmitButtonOnlyForm = ({
    onSubmit, submitting
}: FormSamplesSubmitButtonOnlyFormProps) => {

    const formName = 'FormSubmitButtonOnly';

    return (
        ////////////////////////////////////////////////////////////////////////////
        // This form doesn't use the beforeLeaveText
        // You can navigate away if changes are made without a prompt
        ////////////////////////////////////////////////////////////////////////////
        <Form<T>
            name={formName}
            onSubmit={onSubmit}
            submitting={submitting}
        >
            <FormItem<T>
                formField="firstName"
                label="First Name"
                element={<TextInput maxLength={20} />}
            />
            <FormItem<T>
                formField="lastName"
                label="Last Name"
                element={<TextInput maxLength={20} />}
            />
            <FormButton
                formButtonText='Submit'
                submitButton
                fullWidth
                sx={{ mt: 3, mb: 2 }}
            />
        </Form>
    )
}
